import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import QuestionTable from './QuestionTable';
const Questions = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Questions' parent='Questions'  />
      <Container fluid={true}>
        <Row>
          <QuestionTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default Questions;
